import { colors } from "../../shared/constants";
import { ToastType } from "./index";
export var getColorForToastType = function getColorForToastType(o) {
  var e, r;

  switch (o) {
    case ToastType.ERROR:
      e = colors.red3, r = colors.red1;
      break;

    case ToastType.INFO:
      e = colors.blue1, r = "#ecf5f6";
      break;

    case ToastType.SUCCESS:
      e = colors.green5, r = colors.green1;
      break;

    case ToastType.WARNING:
      e = "#f5a800", r = "#fff7e5";
      break;

    default:
      e = colors.green1, r = colors.green1;
  }

  return {
    borderColor: e,
    backgroundColor: r
  };
};